import React, { useMemo, useState } from "react";

import {
  FaBell,
  FaCheckCircle,
  FaInfoCircle,
  FaBullhorn,
  FaFileAlt,
} from "react-icons/fa";

import "./Notifications.css";


function Notifications() {

  const [activeFilter, setActiveFilter] = useState("all");


  const [notifications, setNotifications] = useState([
    {
      id: 1,
      type: "success",
      icon: <FaCheckCircle />,
      title: "Membership Successfully Renewed",
      description:
        "Your membership has been successfully renewed.",
      date: "20 May 2024",
      read: false,
    },

    {
      id: 2,
      type: "info",
      icon: <FaInfoCircle />,
      title: "Education Support Program",
      description:
        "Registration for the education support program is now open.",
      date: "18 May 2024",
      read: false,
    },

    {
      id: 3,
      type: "announcement",
      icon: <FaBullhorn />,
      title: "Annual General Meeting",
      description:
        "Annual General Meeting will be held on 15 June 2024.",
      date: "15 May 2024",
      read: true,
    },

    {
      id: 4,
      type: "document",
      icon: <FaFileAlt />,
      title: "Membership Documents Available",
      description:
        "Your membership documents are available for download.",
      date: "12 May 2024",
      read: true,
    },
  ]);


  /* ==========================================================
     FILTER NOTIFICATIONS
  ========================================================== */

  const filteredNotifications = useMemo(() => {

    if (activeFilter === "unread") {
      return notifications.filter(
        (notification) => !notification.read
      );
    }

    if (activeFilter === "read") {
      return notifications.filter(
        (notification) => notification.read
      );
    }

    return notifications;

  }, [activeFilter, notifications]);


  /* ==========================================================
     MARK NOTIFICATION AS READ
  ========================================================== */

  const markAsRead = (id) => {

    setNotifications((currentNotifications) =>
      currentNotifications.map((notification) =>
        notification.id === id
          ? {
              ...notification,
              read: true,
            }
          : notification
      )
    );

  };


  /* ==========================================================
     MARK ALL AS READ
  ========================================================== */

  const markAllAsRead = () => {

    setNotifications((currentNotifications) =>
      currentNotifications.map((notification) => ({
        ...notification,
        read: true,
      }))
    );

  };


  return (

    <div className="notifications-page">


      {/* ======================================================
          PAGE HEADER
      ====================================================== */}

      <div className="notifications-page-header">

        <div>

          <h1>
            Notifications
          </h1>

          <div className="notifications-breadcrumb">

            <span>
              Home
            </span>

            <span className="breadcrumb-arrow">
              ›
            </span>

            <span>
              Notifications
            </span>

          </div>

        </div>


        <button
          type="button"
          className="mark-all-button"
          onClick={markAllAsRead}
        >
          Mark all as read
        </button>

      </div>


      {/* ======================================================
          NOTIFICATIONS CARD
      ====================================================== */}

      <section className="notifications-card">


        {/* ====================================================
            FILTERS
        ==================================================== */}

        <div className="notification-filters">

          <button
            type="button"
            className={
              activeFilter === "all"
                ? "filter-button active"
                : "filter-button"
            }
            onClick={() => setActiveFilter("all")}
          >
            All
          </button>


          <button
            type="button"
            className={
              activeFilter === "unread"
                ? "filter-button active"
                : "filter-button"
            }
            onClick={() => setActiveFilter("unread")}
          >
            Unread
          </button>


          <button
            type="button"
            className={
              activeFilter === "read"
                ? "filter-button active"
                : "filter-button"
            }
            onClick={() => setActiveFilter("read")}
          >
            Read
          </button>

        </div>


        {/* ====================================================
            NOTIFICATION LIST
        ==================================================== */}

        <div className="notifications-list">

          {filteredNotifications.length === 0 ? (

            <div className="empty-notifications">

              <div className="empty-notification-icon">
                <FaBell />
              </div>

              <h3>
                No Notifications
              </h3>

              <p>
                There are no notifications in this category.
              </p>

            </div>

          ) : (

            filteredNotifications.map(
              (notification) => (

                <article
                  className={
                    notification.read
                      ? "notification-row read"
                      : "notification-row unread"
                  }
                  key={notification.id}
                  onClick={() =>
                    markAsRead(notification.id)
                  }
                >


                  {/* =========================================
                      ICON
                  ========================================= */}

                  <div
                    className={`notification-row-icon ${notification.type}`}
                  >
                    {notification.icon}
                  </div>


                  {/* =========================================
                      CONTENT
                  ========================================= */}

                  <div className="notification-row-content">

                    <h2>
                      {notification.title}
                    </h2>

                    <p>
                      {notification.description}
                    </p>

                  </div>


                  {/* =========================================
                      DATE
                  ========================================= */}

                  <div className="notification-row-date">

                    {notification.date}

                  </div>


                  {/* =========================================
                      UNREAD INDICATOR
                  ========================================= */}

                  {!notification.read && (

                    <span
                      className="unread-dot"
                      title="Unread"
                    ></span>

                  )}

                </article>

              )
            )

          )}

        </div>

      </section>

    </div>

  );
}


export default Notifications;